import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../common/Button';
import { Modal } from '../common/Modal';
import type { Post } from '../../types/post';

interface PostActionsProps {
  post: Post;
  onDelete?: () => void;
}

export const PostActions: React.FC<PostActionsProps> = ({ post, onDelete }) => {
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleEdit = () => {
    navigate(`/posts/${post.id}/edit`);
  };

  const handleDelete = () => {
    if (onDelete) {
      onDelete();
      setShowDeleteModal(false);
    }
  };

  return (
    <div className="post-actions">
      <Button variant="outline" size="small" onClick={handleEdit}>
        Edit
      </Button>
      <Button variant="danger" size="small" onClick={() => setShowDeleteModal(true)}>
        Delete
      </Button>

      <Modal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title="Delete Post"
        size="small"
      >
        <p>Are you sure you want to delete this post? This action cannot be undone.</p>
        <div className="modal-actions">
          <Button variant="outline" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </div>
      </Modal>
    </div>
  );
};

